import { api } from './client';
import type { InvoiceDto, CreateInvoiceRequest, CreateCreditNoteRequest, UpdateInvoiceMadeRequest, UpdateInvoiceReceivedRequest } from '../types/invoice';

export type { InvoiceDto, CreateInvoiceRequest, CreateCreditNoteRequest };

export const invoicesApi = {
  list: (params: { direction?: string; from?: string; to?: string; q?: string; limit?: number } = {}) =>
    api.get<InvoiceDto[]>('/invoices', {
      direction: params.direction ?? 'Made',
      from: params.from,
      to: params.to,
      q: params.q,
      limit: params.limit ?? 50,
    }),

  getById: (id: number, direction = 'Made') =>
    api.get<InvoiceDto>(`/invoices/${id}`, { direction: String(direction) }),

  create: (data: CreateInvoiceRequest) =>
    api.post<number>('/invoices', data),

  updateMade: (id: number, data: UpdateInvoiceMadeRequest) =>
    api.put<void>(`/invoices/made/${id}`, data),

  updateReceived: (id: number, data: UpdateInvoiceReceivedRequest) =>
    api.put<void>(`/invoices/received/${id}`, data),

  deleteMade: (id: number) =>
    api.delete<void>(`/invoices/made/${id}`),

  deleteReceived: (id: number) =>
    api.delete<void>(`/invoices/received/${id}`),

  post: (id: number, direction = 'Made') =>
    api.post<void>(`/invoices/${id}/post?direction=${encodeURIComponent(direction)}`),

  getPdfUrl: (id: number, direction = 'Made') =>
    `/api/invoices/${id}/pdf?direction=${encodeURIComponent(direction)}`,

  createProforma: (data: CreateInvoiceRequest) =>
    api.post<number>('/invoices/proforma', data),

  convertProforma: (id: number) =>
    api.post<number>(`/invoices/${id}/convert-proforma`),

  bulkPost: (invoiceIds: number[], direction = 'Made') =>
    api.post<{ successCount: number; failureCount: number; errors: string[] }>('/invoices/bulk-post', {
      direction,
      invoiceIds,
    }),

  createCreditNote: (data: CreateCreditNoteRequest) =>
    api.post<number>('/invoices/credit-note', data),
};
